import { CampaignsRoot, ScreenRoot } from "types";

export const CampaignsRootDefinition: ScreenRoot = {
  name: CampaignsRoot,
  routePath: ["/intent-models/*"],
  accessPath: "campaign",
};
